import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CustomLink from '@/components/common/CustomLink';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import { Dialogs, useDialogManager } from '@/modules/Dialogs';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConstituentLifecycleBoardListItem from './ConsituentLifecycleBoardListItem';

function ConstituentLifecycleBoardList({ compact, constituentId }) {
  const { data: constituent } = useConstituent(constituentId);
  const { closeDialog, openDialog } = useDialogManager();
  const { isOrgAdmin, isOrgEditor } = useCurrentUser(true);

  // When dealing with constituent to board relationships, updates aren't
  // immediately available from the constituent object because we don't write
  // this relationship directly to the constituent. For the user to not feel
  // like their changes are buggy, this local copy of constituentBoards will
  // take precendence if set.
  const [constituentBoards, setConstituentBoards] = React.useState();
  const boards = constituentBoards || constituent?.boards || [];

  const openLifecycleDialog = () =>
    openDialog(Dialogs.CONSTITUENT_LIFECYCLE_POSITIONS, {
      constituentBoards: boards,
      constituentId,
      onClose: closeDialog,
      onUpdate: (update) => setConstituentBoards(update),
    });

  return (
    <div>
      <div
        className={classNames('flex items-baseline justify-between', {
          'mb-2': !compact,
        })}
      >
        <h4 className="type-h3">{translate('LIFECYCLE_BOARDS')}</h4>
        {(isOrgAdmin || isOrgEditor) && (
          <CustomLink component="button" onClick={openLifecycleDialog}>
            {translate(boards.length ? 'DONOR_STAGE_INFO_MOVE' : 'ADD')}
          </CustomLink>
        )}
      </div>
      {!!boards.length && (
        <ul
          className={classNames(
            'grid grid-cols-1',
            compact ? 'gap-2' : 'gap-3',
          )}
        >
          {boards.map((board) => (
            <ConstituentLifecycleBoardListItem
              key={board.boardId}
              {...board}
              compact={compact}
            />
          ))}
        </ul>
      )}
    </div>
  );
}

ConstituentLifecycleBoardList.propTypes = {
  compact: PropTypes.bool,
  constituentId: PropTypes.string,
};

ConstituentLifecycleBoardList.defaultProps = {
  compact: false,
  constituentId: null,
};

export default ConstituentLifecycleBoardList;
